import { render } from "./InvoicesSideBar.vue?vue&type=template&id=08aa9791&scoped=true"
import script from "./InvoicesSideBar.vue?vue&type=script&lang=js"
export * from "./InvoicesSideBar.vue?vue&type=script&lang=js"

import "./InvoicesSideBar.vue?vue&type=style&index=0&id=08aa9791&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08aa9791"]])

export default __exports__